import React from 'react';
import Navigation from './Navigation';

const Header = ({ user, onLogout }) => {
    return (
        <header className="header">
            <div className="container">
                <h1>Система учета задолженности</h1>
                <Navigation user={user} onLogout={onLogout} />
            </div>
        </header>
    );
};

export default Header;